export { default as CreateSkillModalController } from './CreateSkillModalController';
export { CreateSkillModal }                      from './CreateSkillModal';



// WEBPACK FOOTER //
// ./src/components/createSkillModal/index.js